import provider from '@/api/apollo-client';
import useList from '../_basic/list';
import gqlList from './list.graphql';

export default function(filters) {
  const searches = new useList(gqlList, filters);

  function loadPure(word) {
    searches.loading.value = true;
    return provider
      .query({
        query: gqlList.loadPure,
        variables: {
          query: word
        },
        fetchPolicy: 'no-cache'
      })
      .then(r => {
        searches.list.value = r.data;
        return r.data;
      })
      .finally(() => {
        searches.loading.value = false;
      });
  }

  return {
    searches: {
      ...searches,
      loadPure
    }
  };
}
